import { isValidAccountNumberExactDigits, isValidAccountNumberMaxDigits, isValidAccountNumberMinDigits, isValidAccountNumberDigits } from "./AccountNumberDigits";

export function isValidAccountFormat(acc,reg_ex){
    return RegExp(reg_ex).test(acc)
}

export function numDigitIsMinMustBeApplied (companydb, userData){
    if(userData.default_settings.hasOwnProperty('companydb') && userData.default_settings.companydb.hasOwnProperty(companydb.companydb_type.value)){
        if(userData.default_settings.companydb[companydb.companydb_type.value].hasOwnProperty('num_digit_is_min')){
            return true
        }
    }
    return false 

}


export function isValidAccountGI(acc,companydb, userData, feature_repo){ 
    // valida que una cuenta de gastos o ingresos tenga un formato válido según esté configurada la empresa o el usuario
    if (userData && numDigitIsMinMustBeApplied(companydb, userData)){
        let num_digit_is_min = userData.default_settings.companydb[companydb.companydb_type.value]['num_digit_is_min']
        if(num_digit_is_min){
            return isValidAccountNumberMinDigits(acc, companydb.num_digits)
        }
    }
    let params = companydb['companydb_type']['params'];
    let feature = feature_repo && feature_repo.got_feature('feature_disable_validation_accounts_format', userData.user, companydb.companydb_type.value);
    if (feature && params.hasOwnProperty('accounts_format')) {
        //Caso cliente con cuentas en formato de 3 dígitos en vez de GXX o IXX en estimasol.
        if (params.hasOwnProperty('accounts_length')) {
            let accounts_length = params['accounts_length'];
            return acc.length === accounts_length;
        }
        return acc.length === companydb.num_digits;
    }
    else if (params.hasOwnProperty('accounts_format')){
        let accounts_format = params['accounts_format']
        return isValidAccountFormat(acc,accounts_format);
    }
    else if (params.hasOwnProperty('accounts_length')){
        let accounts_length = params['accounts_length']
        return isValidAccountNumberExactDigits(acc, accounts_length)
    }
    else if (params.hasOwnProperty('accounts_max_length')){
        let accounts_max_length = params['accounts_max_length']
        if(params.hasOwnProperty('GI_str'))
            return acc.length <= accounts_max_length;
        return isValidAccountNumberMaxDigits(acc, accounts_max_length)
    }
    else if (params.hasOwnProperty('num_digit_is_max_length')){
        let num_digit_is_max = params['num_digit_is_max_length']
        if(num_digit_is_max)
            return isValidAccountNumberMaxDigits(acc, companydb.num_digits)
    }
    return isValidAccountNumberExactDigits(acc, companydb.num_digits)
    
}

export function isValidAccountCS(acc,companydb, userData){
    // valida que una cuenta de proveedor o de cliente tenga un formato válido según esté configurada la empresa o el usuario
    let params = companydb.companydb_type.params
    let valid = true
    if (params.hasOwnProperty('no_check_CS_accounts')){
        return true
    }
    if (params.hasOwnProperty('cif_in_account')){
        valid = isValidAccountFormat(acc,"^[A-Za-z0-9]*$");
    }
    if (!params.hasOwnProperty('accounts_format') && !params.hasOwnProperty('accounts_length') && !params.hasOwnProperty('accounts_max_length')){
        if (params.hasOwnProperty('num_digit_is_max_length')){
            let num_digit_is_max = params['num_digit_is_max_length']
            if(num_digit_is_max){
                if(params.hasOwnProperty('cif_in_account')){
                    return valid && acc.length <= companydb.num_digits
                }
                return valid && isValidAccountNumberMaxDigits(acc, companydb.num_digits)
            }
        }
        else if (userData && numDigitIsMinMustBeApplied(companydb, userData)){
            let num_digit_is_min = userData.default_settings.companydb[companydb.companydb_type.value]['num_digit_is_min']
            if(num_digit_is_min)
                return valid && isValidAccountNumberMinDigits(acc, companydb.num_digits)
        }
        else{
            if(params.hasOwnProperty('cif_in_account')){
                return valid && acc.length === companydb.num_digits
            }
            return valid && isValidAccountNumberExactDigits(acc, companydb.num_digits)
        }
        
    }
    return valid
}

export function isValidAccount(acc, companydb, userData){
    let error = '';
    if(companydb.num_digits && companydb.companydb_type.value!='diezsoftware_nube_au'){
        let num_digit_is_max_length = companydb && companydb.companydb_type && companydb.companydb_type.params && companydb.companydb_type.params['num_digit_is_max_length']
        let num_digit_kind = 'exact';
        if(num_digit_is_max_length){
            num_digit_kind = 'max';
        }
        if(numDigitIsMinMustBeApplied(companydb, userData)){
            num_digit_kind = 'min';
        }
        if(!(companydb && companydb.companydb_type.params.hasOwnProperty('cif_in_account'))){
            if (acc) {
                if(!isValidAccountNumberDigits(acc, companydb.num_digits, num_digit_kind)){
                    if (num_digit_kind == 'exact') {
                        error = "El número de cuenta debe ser de " + companydb.num_digits + " dígitos.";
                    }
                    else if (num_digit_kind == 'max') {
                        error = "El número de cuenta debe ser cómo máximo de " + companydb.num_digits + " dígitos.";
                    }
                    else if (num_digit_kind == 'min') {
                        error = "El número de cuenta debe ser cómo mínimo de " + companydb.num_digits + " dígitos.";
                    }
                }
            }
        }
    }
    return error

}
